<script>
    import { fade, fly } from 'svelte/transition'
    import { shoppingCart, showShoppingCart } from "../../js/stores";
    import Product from "./Product.svelte";
    import { push } from "svelte-spa-router";

    let data = []

    shoppingCart.subscribe((value) => {
        data = value
    })

    function calculatePrice(data) {
        let price = 0
        data.forEach((row) => {
            price += row.price * row.amount
        })
        return price.toFixed(2)
    }

    function closeCart() {
        showShoppingCart.set(false)
    }
</script>

<div class="cart-wrapper">
    <div class="cart-background" transition:fade={{duration: 300}} on:click={closeCart}></div>
    <div class="cart-inner" transition:fly={{duration: 500, x: 600}}>
        <div class="cart-header">
            <h1><i class="fas fa-fw fa-cart-flatbed-boxes"></i>Košík</h1>
            <button type="button" on:click={() => showShoppingCart.set(false)}>
                <i class="far fa-fw fa-xmark"></i>
            </button>
        </div>
        <div class="cart-body">
            <ul>
                {#each data as row}
                    <li>
                        <Product
                          data={row}
                        />
                    </li>
                {/each}
            </ul>
        </div>
        <div class="cart-footer">
            <div class="footer-text">
                <div class="float-left">
                    <h2>Celkom:</h2>
                </div>
                <div class="float-right">
                    <h2>{calculatePrice($shoppingCart)}€</h2>
                    <p>s DPH</p>
                </div>
            </div>
            <button class="btn btn-primary" disabled={($shoppingCart.length === 0)}
                    on:click={() => {showShoppingCart.set(false); setTimeout(() => push('/suhrn'), 100)}}><i
              class="far fa-fw fa-arrow-right-long mr-2"></i>Pokračovať k platbe
            </button>
        </div>
    </div>
</div>

<style>
    :global(html:has(.cart-wrapper)),
    :global(html:has(.cart-wrapper) main) {
        overflow: hidden;
    }
    .cart-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100dvh;
        display: flex;
        justify-content: end;
        z-index: 1000;
    }
    .cart-wrapper .cart-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: #00000080;
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        z-index: 500;
    }
    .cart-wrapper .cart-inner {
        background-color: #FFFFFF;
        width: 33rem;
        min-width: 30vw;
        max-width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        z-index: 800;
    }
    .cart-wrapper .cart-inner .cart-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2rem 1.5rem;
        border-bottom: 1px solid var(--color-slate-200);
    }
    .cart-wrapper .cart-inner .cart-header h1 {
        font-family: Rubik, sans-serif;
        font-weight: 500;
        font-size: 1.7rem;
        color: var(--color-slate-900);
        margin: 0;
    }
    .cart-wrapper .cart-inner .cart-header h1 i {
        font-size: 1.5rem;
        margin-right: .75rem;
    }
    .cart-wrapper .cart-inner .cart-header button {
        font-size: 1.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        width: 3rem;
        height: 3rem;
        cursor: pointer;
        transition: .1s linear;
        color: var(--color-slate-600);
        background-color: var(--color-slate-50);
        border: 1px solid var(--color-slate-200);
    }
    .cart-wrapper .cart-inner .cart-header button:hover {
        color: var(--color-slate-900);
        border-color: var(--color-slate-400);
    }
    .cart-wrapper .cart-inner .cart-body {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .cart-wrapper .cart-inner .cart-body::-webkit-scrollbar {
        width: 5px;
    }
    .cart-wrapper .cart-inner .cart-body::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    .cart-wrapper .cart-inner .cart-body::-webkit-scrollbar-thumb {
        background: #888;
    }
    .cart-wrapper .cart-inner .cart-body::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    .cart-wrapper .cart-inner .cart-body ul {
        list-style-type: none;
        padding: 0;
    }
    .cart-wrapper .cart-inner .cart-body ul li {
        padding: 1rem 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .cart-wrapper .cart-inner .cart-footer {
        background-color: var(--color-slate-50);
        border-top: 1px solid var(--color-slate-200);
        color: #000000;
        height: 15rem;
        padding: 1.5rem 2rem;
        gap: .5rem;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .cart-wrapper .cart-inner .cart-footer h2 {
        font-family: Rubik, sans-serif;
        font-weight: 500;
        color: var(--color-slate-900);
    }
    .cart-wrapper .cart-inner .cart-footer p {
        font-family: Rubik, sans-serif;
        font-weight: 300;
        color: var(--color-slate-500);
        text-align: end;
    }
    .cart-wrapper .cart-inner .cart-footer button {
        height: 4rem;
        width: 100%;
        justify-content: center;
        font-size: 1rem;
    }
</style>